export default {
  primary: '#0077FF',
  primaryLight: '#0077ff2e',
  secondary: '#00C0EE',
  negative: '#C5283D',
  positive: '#32B890',
  textPrimary: '#333',
  backgroundPrimary: '#efefef',
  backgroundSecondary: '#F6F9FC'
};